import * as actions from './actions'
import { EventProps, ExternalProps, SettingsPage, ValueProps } from './SettingsPage'
import { EnrichedSettingsCategory } from './util/SettingsConfigurations'
import { AppState, Dispatch } from '../../types'
import { connect } from 'react-redux'
import selectors from './selectors'

const mapProps = (state: AppState, ownProps: ExternalProps): ValueProps => ({
  ...ownProps,
  selectedEnrichedCategory: selectors.selectedEnrichedCategory(state)
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  changeCategory: (category: EnrichedSettingsCategory) => dispatch(actions.changeCategory(category)),
  changeEnvironment: (category: EnrichedSettingsCategory, envId: string) => dispatch(actions.changeEnvironment(category, envId)),
  initSettings: (selectedCategory?: string, selectedEnvironment?: string) => dispatch(actions.initSettings(selectedCategory, selectedEnvironment))
})

export default connect(mapProps, mapDispatch)(SettingsPage)
